import { render, staticRenderFns } from "./ResetPassPage.vue?vue&type=template&id=2a06513b&"
import script from "./ResetPassPage.vue?vue&type=script&lang=js&"
export * from "./ResetPassPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a06513b')) {
      api.createRecord('2a06513b', component.options)
    } else {
      api.reload('2a06513b', component.options)
    }
    module.hot.accept("./ResetPassPage.vue?vue&type=template&id=2a06513b&", function () {
      api.rerender('2a06513b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ResetPassPage.vue"
export default component.exports